import { JsonpClientBackend } from '@angular/common/http';
import { Component, OnDestroy, OnInit } from '@angular/core';
import { FormBuilder, FormGroup, Validators } from '@angular/forms';
import { ActivatedRoute, Router } from '@angular/router';
import { commonService } from '../services/common.service';
import { dasa } from '../../classess/dasaClasses';
import Swal from 'sweetalert2';
import { test } from 'src/classess/DasaAppUtil';
import { TranslateService } from '@ngx-translate/core';
import { MapBoxTestComponent } from '../share/map-box-test/map-box-test.component';
import { StoreConfigurationsService } from '../services/store-configurations.service';
import { catchError, firstValueFrom, map, Subscription } from 'rxjs';
import { environment } from 'src/environments/environment';
import { DasaThemeMode, ThemeService } from '../services/theme.service';

@Component({
  selector: 'app-login',
  templateUrl: './login.component.html',
  styleUrls: ['./login.component.scss']
})
export class LoginComponent implements OnInit, OnDestroy {
  loginForm: any;
  loading = false;
  submitted = false;
  languageList = [{ code: 'en', label: 'English' }, { code: 'de', label: 'Deutsch' }, { code: 'fr', label: 'Français' }];
  translate: any;
  password: String = 'password';
  showIcon = false;
  themeMode: DasaThemeMode = 'light';
  private themeSub?: Subscription;

  //user:dasa.User = new dasa.User();
  // user_data={
  //   command:'',
  //   user:{
  //     email:'',
  //     password:''
  //   }
  // }
  // user:any;

  usertype: any;
  requestObject: dasa.RequestObject = new dasa.RequestObject();
  imageUrl: any = './assets/img/dasa_multi_black.png';

  constructor(private formBuilder: FormBuilder,
    private route: ActivatedRoute,
    translate: TranslateService,
    private router: Router, private commonService_servive: commonService, private configurationService:StoreConfigurationsService,
    private themeService: ThemeService) {
    this.translate = translate;
    translate.addLangs(['en', 'de', 'fr']);
    translate.setDefaultLang('en');
    translate.use('en');
  }

  ngOnDestroy(): void {
    this.themeSub?.unsubscribe();
    document.body.classList.remove('dasa-auth-page');
  }

  toggleTheme(): void { this.themeService.toggle(); }

  ngOnInit(): void {
    document.body.classList.add('dasa-auth-page');
    this.themeMode = this.themeService.current;
    this.themeSub = this.themeService.modeChanges.subscribe(m => this.themeMode = m);
    if (dasa.Utility.business != undefined && dasa.Utility.business.id > 0) {
      // console.log('Setting image url as :: ' + dasa.Constant.FILE_STREAM_URL + dasa.Utility.business.logo);
      this.imageUrl = dasa.Constant.FILE_STREAM_URL + dasa.Utility.business.logo;
    }

    //this.usertype ='u'
    this.loginForm = this.formBuilder.group({
      loginemail: ['', [Validators.required]],
      loginpassword: ['', [Validators.required, Validators.minLength(4)]],
    });
  }

  showHidePass() {
    if (this.password === 'password') {
      this.password = 'text';
      this.showIcon = true;
    } else {
      this.password = 'password';
      this.showIcon = false;
    }
  }

  get f() {
    return this.loginForm.controls;
  }

  onSubmit() {
    this.submitted = true;
    if (this.loginForm.invalid) {
      return;
    }

    this.requestObject.command = dasa.Constant.ACTION_TYPE_LOGIN_OK;
    dasa.Utility.showBusy();
    this.commonService_servive.doAPICall({email:this.requestObject.user.email,password:this.requestObject.user.password}, environment.NEW_BACKEND_URL+ "login/vendorLogin").subscribe(
      async (res1: any) => {
        const res = res1.data;
        if (res1.success && res.user.id > 0) {
          dasa.Utility.users = res.users;
          dasa.Utility.businesses = res.businesses;
          dasa.Utility.loggedInUser = res.user;
          // Bearer token for the authenticated /api/secure/** endpoints
          // (Revolut merchant credentials). Older backends omit it; the
          // screens that need it say so rather than failing silently.
          dasa.Utility.apiToken = res.apiToken || "";
          dasa.Utility.countries = res.country;
          if (res.user.userGroupId * 1 == dasa.Constant.USER_TYPE_SUPER_ADMIN) {
            await test.DasaAppUtil.putInSession();
            dasa.Utility.hideBusy();
            this.router.navigate(['/admin/business-list'])
          } else if(dasa.Utility.loggedInUser.userGroupId === dasa.Constant.USER_TYPE_BARBER) {
            // Service provider: one store, and only their own reservations / services / reports.
            dasa.Utility.selectedBusinessId = res.user.businessId;
            dasa.Utility.selectedStoreId = res.user.storeId;
            dasa.Utility.serviceProviderId = res.serviceProviderId ?? -1;
            dasa.Utility.selectedCountry = res.country?.[0] || dasa.Utility.selectedCountry;
            const settings = res.myStoreSettings;
            dasa.Utility.stores = settings?.stores || [];
            dasa.Utility.storeSettings = settings?.storeSettings || dasa.Utility.storeSettings;
            dasa.Utility.storeConfigurations = settings?.storeConfigurations
              || await this.getStoreConfigurations(dasa.Utility.selectedStoreId);
            await test.DasaAppUtil.putInSession();
            dasa.Utility.hideBusy();
            return this.navigateClean('admin/reservations-management');
          }
          else if (res.user.userGroupId * 1 == dasa.Constant.USER_TYPE_BUSINESS_ADMIN || res.user.userGroupId * 1 == dasa.Constant.USER_TYPE_STORE_ADMIN) {
            let myStoreSettings = res.myStoreSettings;
            let businessSettings = res.businessSettings;
            if (myStoreSettings != undefined) {
              dasa.Utility.users = myStoreSettings.users;
              dasa.Utility.stores = myStoreSettings.stores;
            }
            else if (businessSettings != undefined) {
              myStoreSettings = businessSettings;
              if(businessSettings.stores.length ==0){
                  dasa.Utility.selectedBusinessId = res.businesses[0]?.id;
                  await test.DasaAppUtil.putInSession();
                  dasa.Utility.hideBusy();
                  this.router.navigate(['/admin/store-registration'])
                  return;
              }

            }
            else {
              dasa.Utility.hideBusy();
              Swal.fire({
                text: 'You are not authorized to login. Please contact the Admin.',
                icon: 'error',
                timer: 1000,
                position: 'center',
                heightAuto: false
              });

            }
            dasa.Utility.selectedCountry = res.country[0];

            if (myStoreSettings.stores.length > 1) {
              // console.log('login successfule store admin redirect to dashboard', res);
              dasa.Utility.stores = myStoreSettings.stores;
              await test.DasaAppUtil.putInSession();
              dasa.Utility.hideBusy();
              this.router.navigate(['/chooseStores']);
              /// show screen to choose between businesses wait
            } else {
              //console.log(myStoreSettings.stores[0].latitude);
              // set lat long
              // Gate on the store existing, not on it having coordinates.
              //
              // This used to read `stores[0]?.latitude !== undefined && !== null`,
              // so a store with no lat/long fell through to the else branch and
              // reported "You are not authorized to login. Please contact the
              // Admin." — a permissions error for what is actually missing map
              // data. Coordinates are only ever assigned by the Google Places
              // `place_changed` listener in setup-vendor, so any store whose
              // address was typed or pasted rather than picked from the
              // autocomplete dropdown was saved with null coordinates and locked
              // its admin out of the portal entirely.
              if (myStoreSettings.stores[0]) {
                const store0: any = myStoreSettings.stores[0];
                if (store0.latitude !== undefined && store0.latitude !== null) {
                  dasa.Utility.latitude = Number(store0.latitude);
                  dasa.Utility.longitude = Number(store0.longitude);
                }
                await test.DasaAppUtil.putInSession();

                // shoow screen to choose between stores
                dasa.Utility.selectedBusinessId = res.businesses[0].id;
                dasa.Utility.selectedStoreId = myStoreSettings.stores[0].id;
                dasa.Utility.stores = [];
                dasa.Utility.stores.push(myStoreSettings.stores[0]);
                dasa.Utility.users = [];
                dasa.Utility.users.push(dasa.Utility.loggedInUser);
                dasa.Utility.brands = myStoreSettings.brands;
                dasa.Utility.categories = myStoreSettings.categories;
                dasa.Utility.storeItems = myStoreSettings.storeItems;
                if(myStoreSettings.storeSettings==undefined){
                  this.commonService_servive.getAPICall("",environment.NEW_BACKEND_URL+ "api/store-settings/by-store/"+dasa.Utility.selectedStoreId).subscribe(
                    (res1: any) => {
                      if(res1.success)
                        dasa.Utility.storeSettings = res1.data;
                    });
                 
                }
                else{
                  dasa.Utility.storeSettings = myStoreSettings.storeSettings;
                }
                await test.DasaAppUtil.putInSession();
                // dasa.Utility.hideBusy();

                // register for notification 
                // this.requestObject.command = dasa.Constant.ACTION_TYPE_REGISTER_USER_NOTIFICATION;
                // this.requestObject.storeId = dasa.Utility.selectedStoreId;
                // this.requestObject.storeAdminId = dasa.Utility.loggedInUser.id;
                // this.commonService_servive.doAPICall(this.requestObject, environment.NEW_BACKEND_URL).subscribe(async (res: any) => {
                // dasa.Utility.socketId = res.socketId;
                // sessionStorage.setItem("sessionSocketId", JSON.stringify(dasa.Utility.socketId));
                // await test.DasaAppUtil.putInSession();
                // go to dashboard page
                // dasa.Utility.hideBusy();
                // if(myStoreSettings.storeConfigurations==undefined){
                const configs = myStoreSettings.storeConfigurations = dasa.Utility.storeConfigurations = await this.getStoreConfigurations(dasa.Utility.selectedStoreId);
                // }
                await test.DasaAppUtil.putInSession();
          
                  // 3) route based on configs (AFTER they’re loaded)
                  if (configs?.serviceBased) {
                    if(dasa.Utility.loggedInUser.userGroupId === dasa.Constant.USER_TYPE_BARBER) {                    
                      return this.navigateClean('admin/reservations-management');                      
                    }
                    return this.navigateClean('/admin/manage-services');
                  } else if (configs?.onlineOrdering || configs?.posEnabled || configs?.cateringEnabled) {
                    // Main dashboard is now the redesigned Analytics
                    // Dashboard (Phase 2). /admin/dashboard routes to it.
                    return this.navigateClean('/admin/dashboard');
                  } else if (configs?.crmEnabled) {
                    return this.navigateClean('/admin/send-bulk-whatsapp-message-to-customers');
                  }else {
                    return this.navigateClean('/admin/store-configurations');
                  }
          
                  
                  // this.router.navigate(['/admin/dashboard']);
                // });
              }
              else {
                dasa.Utility.hideBusy();
                Swal.fire({
                  text: 'You are not authorized to login. Please contact the Admin.',
                  icon: 'error',
                  timer: 1000,
                  position: 'center',
                  heightAuto: false
                });
              }

              // register for notification
            }
          }
        }
        else {
          dasa.Utility.hideBusy();
          Swal.fire({
            text: 'You are not authorized to login.',
            icon: 'error',
            timer: 1000,
            position: 'center',
            heightAuto: false
          });
        }
      },
      error => {
        dasa.Utility.hideBusy();
        console.log('error test', error)
      }
    )
    // if(this.usertype =='u')
    // {  
    // }
  }
  private async getStoreConfigurations(storeId: number): Promise<any | null> {
    try {
      const res: any = await firstValueFrom(
        this.configurationService.getStoreConfigurations(storeId).pipe(
          map(r => r?.data ?? null),
          catchError(() => [null] as any)
        )
      );
      return res;
    } catch {
      return null;
    }
  }
  
  // small helpers
  private navigateClean(path: string) {
    dasa.Utility.hideBusy();
    this.router.navigate([path]);
  }
}
